import { render, staticRenderFns } from "./GuardianClient.vue?vue&type=template&id=c403d3c2&"
import script from "./GuardianClient.vue?vue&type=script&lang=js&"
export * from "./GuardianClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports